module.exports = "### Helsinki City Logo\n\n##### Language versions\n\nThere are language versions from the logo.\n\n##### Using logo color with mixin\n\n`@mixin helsinki-logo($_color)` where\n\n`$_color` can be any color\n\n###### Example\n`@include helsinki-logo($black);`\n`height: $line-height-computed * 4;`\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./src/components/docs/styles/Logo/Logo.md
// module id = 261
// module chunks = 0